import React from 'react';

interface TwoColProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function TwoCol({ children, className = '', ...rest }: TwoColProps) {
    const classes = ['two-col', className].filter(Boolean).join(' ');
    return (
        <div className={classes} {...rest}>
            {children}
        </div>
    );
}
